.label-field-container {
    width: 100%;
    min-width: 180px;
    margin-left: -4px;
}
